import { request } from "../../apis";

export const apiGetPaymentMethodList = (): any =>
  request("get", `/api/payment/method/list`, null, true);

export const apiCheckout = (params: any) =>
  request("post", `/api/order/create/batch`, params, true, true);

export const apiUpdateCompanion = (params: any) =>
  request("post", `/api/order/update/companion`, params, true, true);

export const apiCreatePayment = (params: any) =>
  request("post", `/api/payment/create`, params, true, true);

export const apiUpdateRemark = (params: any) =>
  request("post", `/api/order/update/remark`, params, true, true);
